import { render, staticRenderFns } from "./userAgreeOn.vue?vue&type=template&id=6b9668ec&scoped=true&"
import script from "./userAgreeOn.vue?vue&type=script&lang=js&"
export * from "./userAgreeOn.vue?vue&type=script&lang=js&"
import style0 from "./userAgreeOn.vue?vue&type=style&index=0&id=6b9668ec&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9668ec",
  null
  
)

export default component.exports